<template>
    <v-container fluid class="white elevation-4 pt-0">
        <main-app-bar title="Settings"></main-app-bar>
        <v-form ref="settingsForm">
            <v-container class="px-5">
                <v-layout row px-4>
                    <v-flex xs3 class="d-flex align-center">
                        <p class="ma-0">Spot check random tasks amount</p>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field
                            placeholder="Enter count"
                            type="number"
                            v-model="spotCheckTasksAmount"
                            :rules="tasksAmountRules"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row px-4>
                    <v-flex xs3 class="d-flex align-center">
                        <p class="ma-0">Max points for task</p>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field
                            placeholder="Enter value"
                            type="number"
                            v-model="maxAppraisalPoints"
                            :rules="tasksAmountRules"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row px-4>
                    <v-flex xs3 pr-4 class="d-flex align-center">
                        <p class="ma-0">Auto-autorized Sick leave days</p>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field
                            placeholder="Enter value"
                            type="number"
                            v-model="autoSickLeaves"
                            :rules="tasksAmountRules"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row px-4 mt-5>
                    <v-flex xs3 class="d-flex align-center">
                        <p class="ma-0">Xero login</p>
                    </v-flex>
                    <v-flex xs2>
                        <v-btn
                            :href="xeroLoginHref"
                        >Login</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout row px-4 mt-5 align-center>
                    <v-flex xs3 pr-4>
                        Preselected roles
                    </v-flex>
                    <v-flex xs3 class="d-flex align-center">
                        <v-autocomplete
                            :items="getVisibleRoles"
                            item-text="title"
                            item-value="id"
                            placeholder="Role"
                            v-model="rotaRoleIds"
                            dense
                            solo
                            lighten-1
                            multiple
                            :search-input.sync="searchInputAutocomplete[selectInputConst.roles]"
                        >
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" class="selection-text-style">{{ item.title }}</span>
                                <span v-if="index === 1" class="selection-text-style">, {{ item.title }}</span>
                                <span
                                    v-if="index === 2"
                                    class="grey--text caption"
                                >(+{{ rotaRoleIds.length - 2 }} others)</span>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout row px-4 mt-5 align-center>
                    <v-flex xs3 pr-4>
                        Contracted Hours change notify
                    </v-flex>
                    <v-flex xs3 class="d-flex align-center">
                        <v-autocomplete
                            :items="employeeList"
                            item-text="value"
                            item-value="id"
                            placeholder="Employee"
                            v-model="chosenEmployee"
                            dense
                            solo
                            lighten-1
                            multiple
                            :loading="employeeLoading"
                            :search-input.sync="searchInputAutocomplete[selectInputConst.employee]"
                        >
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" class="selection-text-style">{{ item.value }}</span>
                                <span v-if="index === 1" class="selection-text-style">, {{ item.value }}</span>
                                <span
                                    v-if="index === 2"
                                    class="grey--text caption"
                                >(+{{ chosenEmployee.length - 2 }} others)</span>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout row px-4 mt-5 align-center>
                    <v-flex xs3 pr-4>
                        Manage breakdown log job types
                    </v-flex>
                    <v-flex xs3 class="d-flex align-center">
                        <v-btn @click.stop="jobTypesManageModal = true" color="primary">
                            Manage
                        </v-btn>
                        <BreakdownLogsJobTypesManageDialog :isOpen='jobTypesManageModal' @closeDialog='closeJobTypesManageModal'/>
                    </v-flex>
                </v-layout>
                <v-layout row px-4 mt-5 align-center>
                    <v-flex xs3 pr-4>
                        Resources
                    </v-flex>
                    <v-flex xs3 class="d-flex align-center">
                        <v-btn @click.stop="resourcesDialogOpen = true" color="primary">
                            Manage
                        </v-btn>
                        <ResourcesDialog :isOpen.sync="resourcesDialogOpen" />
                    </v-flex>
                </v-layout>
                <v-layout row px-4 mt-5 align-center>
                    <v-flex xs3 pr-4>
                        Google Marketing Sheet
                    </v-flex>
                    <v-flex xs3 class="d-flex align-center">
                        <v-text-field
                            placeholder="Enter URL"
                            v-model="googleMarketingSheetUrl"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveSettings">Save</v-btn>
                </v-card-actions>
            </v-container>
        </v-form>
    </v-container>
</template>

<script>
    import MainAppBar from '@/components/MainAppBar'
    import { mapActions, mapGetters } from 'vuex'
    import config from '@/common/config'
    import selectInputAutocomplete from '../../constatns/selectInputAutocomplete'
    import BreakdownLogsJobTypesManageDialog from '@/views/settings/BreakdownLogsJobTypesManageDialog'
    import ResourcesDialog from '@/views/settings//ResourcesDialog'

    export default {
        components: {
            BreakdownLogsJobTypesManageDialog,
            MainAppBar,
            ResourcesDialog
        },
        data: () => ({
            spotCheckTasksAmount: null,
            maxAppraisalPoints: null,
            autoSickLeaves: null,
            googleMarketingSheetUrl: '',
            tasksAmountRules: [
                value => !!value || 'Required.',
                value => (value && Number(value) > 0) || 'Value should be more than 0'
            ],
            rotaRoleIds: [],
            selectInputConst: selectInputAutocomplete,
            searchInputAutocomplete: {
                [selectInputAutocomplete.roles]: null,
                [selectInputAutocomplete.employee]: null
            },
            employeeLoading: false,
            employeeList: [],
            chosenEmployee: [],
            jobTypesManageModal: false,
            resourcesDialogOpen: false
        }),
        async mounted () {
            this.spotCheckTasksAmount = this.$store.getters.getSpotCheckTasksAmount
            this.maxAppraisalPoints = this.$store.getters.getMaxAppraisalPoints
            this.rotaRoleIds = Array.isArray(this.$store.getters.getRotaRoleIds) ? [...this.$store.getters.getRotaRoleIds] : []
            this.chosenEmployee = Array.isArray(this.$store.getters.getNotifyUpdateRotaDefaultsEmployeeIds) ? [...this.$store.getters.getNotifyUpdateRotaDefaultsEmployeeIds] : []
            this.autoSickLeaves = this.$store.getters.getAutoAutorizedSickLeaveDays
            this.googleMarketingSheetUrl = this.$store.getters.getGoogleMarketingSheetUrl
            if (!this.getVisibleRoles.length) this.fetchRoles()
            try {
                this.employeeLoading = true
                const localEmployee = await this.getActiveEmployee()
                this.employeeList = localEmployee.employees
                this.employeeLoading = false
            } catch (e) {
                this.employeeLoading = true
            }
            this.$store.dispatch('fetchBreakdownLogJobTypes')
        },
        computed: {
            ...mapGetters(['getVisibleRoles', 'getWebResources']),
            xeroLoginHref () {
                return config.apiUrl + 'xero/login'
            }
        },
        methods: {
            ...mapActions(['setSettings', 'showAlert', 'fetchRoles', 'getActiveEmployee']),
            saveSettings: function () {
                if (this.$refs.settingsForm.validate()) {
                    this.setSettings({
                        spotCheckTasksAmount: this.spotCheckTasksAmount,
                        maxAppraisalPoints: this.maxAppraisalPoints,
                        rotaRoleIds: this.rotaRoleIds,
                        notifyUpdateRotaDefaultsEmployeeIds: this.chosenEmployee,
                        autoAutorizedSickLeaveDays: this.autoSickLeaves,
                        googleMarketingSheetUrl: this.googleMarketingSheetUrl,
                        webResources: this.getWebResources
                    }).then(() => {
                        this.showAlert({
                            text: 'Saved!',
                            type: 'success'
                        })
                    }).catch(() => {
                        this.showAlert({
                            text: 'Something was wrong, please try again',
                            type: 'error'
                        })
                    })
                }
            },
            closeJobTypesManageModal () {
                this.jobTypesManageModal = false
            },
            changeOption (typeSearch) {
                this.searchInputAutocomplete[typeSearch] = ''
            }
        }
    }
</script>

<style>

</style>
